import { approvalsEntriesQueryKey, approvalsTimesheetsQueryKey, } from './query-key';
export function invalidateApprovalsTimesheetsQuery(queryClient) {
    return queryClient.invalidateQueries({ queryKey: approvalsEntriesQueryKey });
}
export function invalidateApprovalsEntriesQuery(queryClient) {
    return queryClient.invalidateQueries({
        queryKey: approvalsTimesheetsQueryKey,
    });
}
//# sourceMappingURL=query.js.map